import moment from 'moment';

export const formatPhoneNumber = (phoneNumber) => {
  var cleaned = ('' + phoneNumber).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
};

export const isPlural = (number) => {
    return number > 1 ? 's':'';
}

export const milesToKm = (miles) => {
  return miles*1.60934;
}

export const kmToMiles = (km) => {
  return km*0.621371;
}


export const doFiltering = (filteredMarkers, filters, dynamicAmenities, dynamicUtilities, dynamicRoommateAttributes, distanceType) => {
    Object.entries(filters)
      .filter(([key, value]) => value !== '')
      .forEach(([key, val]) => {
        if (key === 'unitTypeTitle') {
          filteredMarkers = filteredMarkers.filter(
            (x) => x.unitTypeTitle === val
          );
        } else if (key === 'rent') {
          filteredMarkers = filteredMarkers.filter(
            (x) => parseFloat(x.rent) <= parseFloat(val)
          );
        } else if (key === 'bedroomCount') {
          filteredMarkers = filteredMarkers.filter(
            (x) => parseInt(x.bedroomCount) === parseInt(val)
          );
        } else if (key === 'availableDate') {
          filteredMarkers = filteredMarkers.filter((x) =>
            moment(x.dateAvailable).isBefore(
              moment(val, 'MM/DD/YYYY').format('YYYY-MM-DD'),
              'day'
            )
          );
        } else if (key === 'leaseTypeTitle') {
          filteredMarkers = filteredMarkers.filter(
            (x) => x.leaseTypeTitle === val
          ); 
        } else if (key === 'locationGroupTitle') {
          filteredMarkers = filteredMarkers.filter(
            (x) => x.locationGroupTitle === val
          );
        } else if (key === 'distanceFromCampus') {
          if (distanceType === 'mile') {
            filteredMarkers = filteredMarkers.filter((x) => x.distanceFromCampus <= val);
          } else {
            filteredMarkers = filteredMarkers.filter((x) => x.distanceFromCampus <= kmToMiles(val));
          }
        } else {
          dynamicAmenities.forEach((filterVar) => {
            if (key === filterVar['key'] && val) {
              filteredMarkers = filteredMarkers.filter((x) => 
                x.amenities.includes(filterVar['value'])
              );
            }
          });
          dynamicUtilities.forEach((filterVar) => {
            if (key === filterVar['key'] && val) {
              filteredMarkers = filteredMarkers.filter((x) => 
                x.utilities.includes(filterVar['value'])
              );
            }
          });
          dynamicRoommateAttributes.forEach((filterVar) => {
            if (key === filterVar['key'] && val) {
              filteredMarkers = filteredMarkers.filter((x) => 
                x.roommateAttributes.includes(filterVar['value'])
              );
            }
          });
        }     
      });
      return filteredMarkers;
}

